import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { portfolio } from "../data/portfolio";
import { AnimatedCounter } from "./AnimatedCounter";
import { MotionFade } from "./MotionFade";

export function StatsBand() {
  return (
    <Box as="section" aria-label="Números" px={{ base: 5, md: 8 }} position="relative" zIndex={1} bg="graphite.950">
      <Box maxW="container.xl" mx="auto" borderTopWidth="1px" borderBottomWidth="1px" borderColor="whiteAlpha.200">
        <SimpleGrid columns={3}>
          {portfolio.stats.map((stat, i) => (
            <MotionFade
              key={stat.label}
              delay={i * 0.1}
              py={{ base: 7, md: 12 }}
              pr={{ base: 2, md: 8 }}
              pl={i === 0 ? 0 : { base: 3, md: 8 }}
              borderLeftWidth={i === 0 ? 0 : "1px"}
              borderColor="whiteAlpha.200"
            >
              <AnimatedCounter
                value={stat.value}
                prefix={stat.prefix}
                suffix={stat.suffix}
                display="block"
                fontFamily="heading"
                fontWeight="700"
                fontSize={{ base: "clamp(1.6rem, 9vw, 2.5rem)", sm: "3.5rem", md: "5rem", lg: "6.5rem" }}
                whiteSpace="nowrap"
                lineHeight="1"
                letterSpacing="-0.05em"
                color="white"
                sx={{ fontVariantNumeric: "tabular-nums" }}
              />
              <Text mt={3} fontFamily="mono" fontSize={{ base: "10px", md: "xs" }} lineHeight="1.5" letterSpacing={{ base: "0.04em", md: "0.1em" }} textTransform="uppercase" color="graphite.400">
                {stat.label}
              </Text>
            </MotionFade>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
}
